module.exports = __webpack_public_path__ + "img/mahsulotlar.294d37f6.png";